document.addEventListener("DOMContentLoaded", () => {
  function sameHeightCompare() {
    let compare_max_height = 0;
    $(
      ".procomparison-probox .procomparison-itemspec:not(:first-child) .height_item"
    ).each(function () {
      if (compare_max_height < $(this).height()) {
        compare_max_height = $(this).height();
      }
    });
    $(
      ".procomparison-probox .procomparison-itemspec:not(:first-child) .height_item"
    ).css({
      height: `${compare_max_height}px`,
    });
  }
  sameHeightCompare();
  $(window).resize(function () {
    sameHeightCompare();
  });

  var rewardSwiper = new Swiper(".procomparison_right", {
    slidesPerView: 3,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination",
      type : 'progressbar',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      200: {
        slidesPerView: 1.6,
        spaceBetween: 8,
      },
    },
  });
  
});
